import { css } from 'styled-components';

export default css`
  margin-top: 20px;
  padding: 5px;
  border: solid 0.5px;
  border-color: rgb(66, 67, 68);
`;
